import React, { useState, useEffect} from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { } from 'react-bootstrap';
import { Route, Routes, NavLink, useLocation } from 'react-router-dom';
import './App.css';
import useContactForm from "./hooks/useContactForm";
import { CATEGORY_ITEMS, allCategoryItems } from "./data/guestPostCategories";

// import ScrollToTop from './components/ScrollToTop';

// import 'bootstrap/dist/css/bootstrap.min.css';
// import 'bootstrap/dist/js/bootstrap.bundle.min.js';
// import '@fortawesome/fontawesome-free/css/all.min.css';
import 'slick-carousel';
// import 'slick-carousel/slick/slick.css';
// import 'slick-carousel/slick/slick-theme.css';
// import WebsiteDevPopup from "./pages/WebsiteDevPopup";
const WebsiteDevPopup = React.lazy(() => import('./pages/WebsiteDevPopup'));

const ScrollToTop = React.lazy(() => import('./components/ScrollToTop'));
const Home = React.lazy(() => import('./pages/Home'));

//const OffshoreMarketingTeam = React.lazy(() => import('./pages/OffshoreMarketingTeam'));
//const OffshoreWebDevelopers = React.lazy(() => import('./pages/OffshoreWebDevelopers'));
const DigitalMarketing = React.lazy(() => import('./pages/DigitalMarketing'));
const WebDesignDevelopment = React.lazy(() => import('./pages/WebDesignDevelopment'));
const BlogDetails = React.lazy(() => import('./pages/BlogDetails'));
const ContactUs = React.lazy(() => import('./pages/ContactUs'));
const AboutUs = React.lazy(() => import('./pages/AboutUs'));
const PrivacyPolicy = React.lazy(() => import('./pages/PrivacyPolicy'));
const GuestPosting = React.lazy(() => import('./pages/GuestPosting'));
const PaidCitations = React.lazy(() => import('./pages/PaidCitations'));
const ContentWriting = React.lazy(() => import('./pages/ContentWriting'));
const LinkInsertion = React.lazy(() => import('./pages/LinkInsertion'));
const CategoryGuestPosting = React.lazy(() => import('./pages/CategoryGuestPosting'));
const Page404 = React.lazy(() => import('./pages/Page404'));
const ThankYou = React.lazy(() => import('./pages/ThankYou'));
const BlogTest = React.lazy(() => import('./pages/BlogTest'));
const Urlchecker = React.lazy(() => import('./pages/Urlchecker'));

const homeUrl = process.env.REACT_APP_HOME_URL;
const categoryHrefMap = allCategoryItems.reduce((acc, item) => {
	acc[item.label] = item.href;
	return acc;
}, {});

const App = () => {
  const {
    formData,
    handleChange,
    handleSubmit,
    loading,
    status,
    setCaptchaToken,
  } = useContactForm();
  const [expanded, setExpanded] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const location = useLocation();
  const hideFooter = ['/blog', '/blog-details', '/contact-us', '/thank-you', '/backlink-audit-thank-you'].includes(location.pathname);
  const [isSticky, setIsSticky] = useState(false);
  

  // Sticky navbar on scroll
  useEffect(() => {
  	 import('bootstrap/dist/js/bootstrap.bundle.min.js');
    const handleScroll = () => {
      setIsSticky(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Collapse navbar on route change (mobile fix)
  useEffect(() => {
	setExpanded(false);
	setOpenDropdown(null);
  }, [location]);
 

  return (
  <>
	<ScrollToTop />
	<div className="App">
		<header className={`header ${isSticky ? "sticky" : ""}`}>
			<div className="header_mainsec">
				<nav className="navbar navbar-expand-lg">
					<div className="container">
						<div className="header_innerbox">
							<NavLink to="/" className="navbar-brand">
								<img src={`${homeUrl}/assets/img/Hypwave-Final-Logo.png`} alt="Hypwave Logo" loading="lazy"/>
							</NavLink>
							
							<button
								className="navbar-toggler"
								type="button"
								aria-controls="navbarSupportedContent"
								aria-expanded={expanded}
								aria-label="Toggle navigation"
								onClick={() => setExpanded(prev => !prev)}
							  >
								<span className="navbar-toggler-icon"></span>
							</button>
							
							<div className={`navbar-collapse ${expanded ? "show" : "collapse"}`} >
								<ul className="navbar-nav">
									<li className="nav-item">
										<NavLink className={({ isActive }) => (isActive ? "nav-link active" : "nav-link")} to="/" onClick={() => setExpanded(false)} >
											Home
										</NavLink>
									</li>
									
									<li className="nav-item">
										<NavLink className={({ isActive }) => (isActive ? "nav-link active" : "nav-link")} to="/about" onClick={() => setExpanded(false)} >
											About Us
										</NavLink>
									</li>
									
									<li className="nav-item dropdown categories-dropdown-parent">
										<NavLink
											className={({ isActive }) => (isActive ? "nav-link active" : "nav-link")}
											to="/guest-posting-services"
											onClick={(e) => {
												if (window.innerWidth <= 991) {
													e.preventDefault();
													setOpenDropdown((prev) => (prev === "link-building" ? null : "link-building"));
													return;
												}
												setExpanded(false);
											}}
										>
											Link Building <i className="fas fa-angle-down"></i>
										</NavLink>
										
										<ul className={`dropdown-menu ${openDropdown === "link-building" ? "show" : ""}`} aria-labelledby="navbarDropdown">
											<li><NavLink className="dropdown-item" to="/guest-posting-services" onClick={() => setExpanded(false)}>Guest Posting</NavLink></li>
											<li><NavLink className="dropdown-item" to="/link-insertion-services" onClick={() => setExpanded(false)}>Link Insertion</NavLink></li>
											<li><NavLink className="dropdown-item" to="/citations-services" onClick={() => setExpanded(false)}>Citations</NavLink></li>
										</ul>
									</li>
									
									<li className="nav-item">
										<NavLink className={({ isActive }) => (isActive ? "nav-link active" : "nav-link")} to="/content-writing-services" onClick={() => setExpanded(false)} >
											Content Writing
										</NavLink>
									</li>

									<li className="nav-item dropdown">
										<NavLink
											className={({ isActive }) => (isActive ? "nav-link active" : "nav-link")}
											to="/category/technology"
											onClick={(e) => {
												if (window.innerWidth <= 991) {
													e.preventDefault();
													setOpenDropdown((prev) => (prev === "categories" ? null : "categories"));
													return;
												}
												setExpanded(false);
											}}
										>
											Categories <i className="fas fa-angle-down"></i>
										</NavLink>
										<ul className={`dropdown-menu category-dropdown-menu ${openDropdown === "categories" ? "show" : ""}`} aria-labelledby="navbarDropdown">
											{CATEGORY_ITEMS.map((item) => (
												<li key={item}>
													<NavLink
														className="dropdown-item"
														to={categoryHrefMap[item]}
														onClick={() => setExpanded(false)}
													>
														{item}
													</NavLink>
												</li>
											))}
										</ul>
									</li>
									
									{/*<li className="nav-item dropdown">
										<NavLink className="nav-link dropdown-item dropdown-toggle" to="/hire" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">Hire</NavLink>
										
										<ul className="dropdown-menu" aria-labelledby="navbarDropdown">
											<li><NavLink className="dropdown-item" to="/hire-offshore-marketing-team" onClick={() => setExpanded(false)}>Offshore Marketing Team</NavLink></li>
											<li><NavLink className="dropdown-item" to="/hire-offshore-web-developers" onClick={() => setExpanded(false)}>Offshore Web developers</NavLink></li>
										</ul>
									</li>
									
									<li className="nav-item dropdown">
										<NavLink className="nav-link dropdown-item dropdown-toggle" to="/for-agency" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">Services</NavLink>
										
										<ul className="dropdown-menu" aria-labelledby="navbarDropdown">
											{/*<li><NavLink className="dropdown-item" to="/offshore-digital-marketing-services" onClick={() => setExpanded(false)}>Digital Marketing</NavLink></li>
											
											<li><NavLink className="dropdown-item" to="/offshore-web-design-development-services" onClick={() => setExpanded(false)}>Web Design & Development</NavLink></li>
										</ul>
									</li>*/}
									
									
									<li className="nav-item">
										<NavLink className={({ isActive }) => (isActive ? "nav-link active" : "nav-link")} to="/blog">Blogs</NavLink>
									</li>

									<li className="nav-item dropdown">
										<NavLink
											className={({ isActive }) => (isActive ? "nav-link active" : "nav-link")}
											to=""
										>
											Tools <i className="fas fa-angle-down"></i>
										</NavLink>
										<ul className={`dropdown-menu category-dropdown-menu ${openDropdown === "categories" ? "show" : ""}`} aria-labelledby="navbarDropdown">
											
												<li key="blog-generator">
													<NavLink
														className="dropdown-item"
														target="_blank"
    												rel="noopener noreferrer"
														to="https://bloggenerator.hypwave.com/"
														onClick={() => setExpanded(false)}
													>
														Blog Generator
													</NavLink>
												</li>

												<li key="ai-content-detector">
													<NavLink
														className="dropdown-item"
														target="_blank"
    												rel="noopener noreferrer"
														to="https://aicontentchecker.hypwave.com/"
														onClick={() => setExpanded(false)}
													>
														AI Content Detector
													</NavLink>
												</li>
												
												<li key="ai-humanizer">
													<NavLink
														className="dropdown-item"
														target="_blank"
    												rel="noopener noreferrer"
														to="https://aihumanizer.hypwave.com/"
														onClick={() => setExpanded(false)}
													>
														AI Humanizer
													</NavLink>
												</li>
												
												<li key="ai-humanizer">
													<NavLink
														className="dropdown-item"
														target="_blank"
    												rel="noopener noreferrer"
														to="https://toxic-backlinks-checker.hypwave.com/"
														onClick={() => setExpanded(false)}
													>
														Toxic Backlinks Checker
													</NavLink>
												</li>
											
										</ul>
									</li>

									
									
									<li className="nav-item contact_menu">
										<NavLink className={({ isActive }) => (isActive ? "nav-link active" : "nav-link")} to="/contact-us" onClick={() => setExpanded(false)}>Contact Us</NavLink>
									</li>
								</ul>
							</div>
							
							<div className="btn_mainsec">
								<NavLink className="btn_style" to="/contact-us">Contact Us</NavLink>
							</div>
						</div>
					</div>
				</nav>
			</div>
		</header>
	
		<Routes>      
			<Route exact path="/" element={<Home />} />
			<Route exact path="/offshore-digital-marketing-services" element={<DigitalMarketing />} />
			<Route exact path="/offshore-web-design-development-services" element={<WebDesignDevelopment />} />
			<Route exact path="/blog/:blog_slug" element={<BlogDetails />} />

			<Route exact path="/blog" element={<BlogTest />} />
			
			<Route exact path="/contact-us" element={<ContactUs />} />
			<Route exact path="/about" element={<AboutUs />} />
			<Route exact path="/privacy-policy" element={<PrivacyPolicy />} />
			<Route exact path="/guest-posting-services" element={<GuestPosting />} />
			<Route exact path="/category/technology" element={<CategoryGuestPosting fixedCategory="technology" />} />
			<Route exact path="/category/technolog" element={<CategoryGuestPosting fixedCategory="technolog" />} />
			<Route exact path="/category/:categorySlug" element={<CategoryGuestPosting />} />
			<Route exact path="/guest-post/category/:categorySlug" element={<CategoryGuestPosting />} />
			<Route exact path="/categories/:categorySlug" element={<CategoryGuestPosting />} />
			<Route exact path="/citations-services" element={<PaidCitations />} />
			<Route exact path="/content-writing-services" element={<ContentWriting />} />
			<Route exact path="/link-insertion-services" element={<LinkInsertion />} />
			<Route exact path="*" element={<Page404 />} />
			<Route exact path="/thank-you" element={<ThankYou />} />
			<Route exact path="/backlink-audit-thank-you" element={<ThankYou />} />
			<Route exact path="/404-url-checker" element={<Urlchecker />} />
		</Routes>
		
		
		<footer>
			{!hideFooter && (
				<div id="footerform" className="contactform_mainsec">
					<div className="container">
						<div className="row">
							<div className="col-sm-12 col-md-4 col-lg-4 col-xl-4">
								<div className="title_box">
									<h3>We’d Love To <span className="highlight_normaltxt">Hear From</span> You</h3>
									<p>Get Custom Solutions, Recommendations, and Estimates. Confidentiality & Same Day Response Guaranteed!</p>
								</div>
							</div>

							<div className="col-sm-12 col-md-8 col-lg-8 col-xl-8">
								<div className="form_mainsec">
								  <form onSubmit={handleSubmit}>
								  <div className="row">
								{/* First Name */}
								<div className="col-sm-12 col-md-6 col-lg-6 col-xl-6">
								  <div className="form-group">
									<label className="form-label">First Name</label>
									<input
									  type="text"
									  className="form-control"
									  name="first_name"
									  placeholder="First Name"
									  required
									  value={formData.first_name}
									  onChange={handleChange}
									/>
								  </div>
								</div>

								{/* Last Name */}
								<div className="col-sm-12 col-md-6 col-lg-6 col-xl-6">
								  <div className="form-group">
									<label className="form-label">Last Name</label>
									<input
									  type="text"
									  className="form-control"
									  name="last_name"
									  placeholder="Last Name"
									  required
									  value={formData.last_name}
									  onChange={handleChange}
									/>
								  </div>
								</div>

								  {['email', 'country', 'phone', 'message'].map((field, index) => (
									  <div
										key={field}
										className={`col-sm-12 col-md-${field === 'email' || field === 'message' ? '12' : '6'} col-lg-${field === 'email' || field === 'message' ? '12' : '6'} col-xl-${field === 'email' || field === 'message' ? '12' : '6'}`}
									  >
										<div className="form-group">
										  <label className="form-label">
											{field === 'email' && 'Email Address'}
											{field === 'country' && 'Country'}
											{field === 'phone' && 'Phone Number'}
											{field === 'message' && 'Description'}
										  </label>
										  {field === 'message' ? (
											<textarea
											  className="form-control"
											  name={field}
											  placeholder="Description"
											  value={formData[field]}
											  onChange={handleChange}
											/>
										  ) : (
											<input
											  type={field === 'email' ? 'email' : 'text'}
											  className="form-control"
											  name={field}
											  placeholder={
												field === 'email'
												  ? 'Email Address'
												  : field === 'country'
												  ? 'Country'
												  : field === 'phone'
												  ? 'Phone Number'
												  : ''
											  }
											  required
											  value={formData[field]}
											  onChange={handleChange}
											/>
										  )}
										</div>
									  </div>
									))}

									<div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-4">
										<ReCAPTCHA
											sitekey="6Lfl1CsrAAAAADoD-fT8m8_iSjHkWQ0gcfKy8SYc"
											onChange={(token) => setCaptchaToken(token)}
										/>
									</div>
									
									<div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
									  <div className="btn_mainsec">
										<button type="submit" className="btn_style" disabled={loading}>
										  {loading ? 'Sending...' : 'Submit'}
										</button>
									  </div>
									</div>
								  </div>

								  {status && <p className="text-light">{status}</p>}
								</form>
								</div>
							</div>
						</div>
					</div>
				</div>
			)}

			<div className="footer_mainsec">
				<div className="container">
					<div className="row">
						<div className="col-sm-12 col-md-6 col-lg-3 col-xl-3">
							<div className="logotxt_sec">
								<div className="logobox">
									<NavLink to="/" className="navbar-brand">
										<img src={`${homeUrl}/assets/img/Hypwave-Final-Logo.png`} alt="Hypwave Logo" loading="lazy"/>
									</NavLink>
								</div>
								
								
								
								<div className="logocontnt">
									<p>We make link building easy. From citations to guest posts to content marketing, we help your brand gain trust, visibility, and growth online.</p>
								</div>
								
							</div>
							
							<div className="followbox">
								<div className="titlebox">
									<h4>Follow Us</h4>
								</div>
							
								<ul>
									<li><NavLink target="_blank" to="https://www.facebook.com/people/Hypwave/61578754176093/"><i className="fab fa-facebook-square"></i></NavLink></li>
									<li><NavLink target="_blank" to="https://www.instagram.com/hypwave_team"><i className="fab fa-instagram-square"></i></NavLink></li>
									<li><NavLink target="_blank" to="https://x.com/Hypwave"><i className="fa-brands fa-square-x-twitter"></i></NavLink></li>
									<li><NavLink target="_blank" to="https://youtube.com/@hypwave?si=P4c8hMz5vJkH3N9F"><i className="fab fa-youtube-square"></i></NavLink></li>
									<li><NavLink target="_blank" to="https://www.linkedin.com/company/hypwave/"><i className="fab fa-linkedin"></i></NavLink></li>
								</ul>
							</div>
						</div>
						
						<div className="col-sm-12 col-md-6 col-lg-2 col-xl-2">
							<div className="menubox company_menu">
								<div className="titlebox">
									<h4>Company</h4>
								</div>
								
								<ul>
									<li><NavLink to="#">Home</NavLink></li>
									<li><NavLink to="/about">About Us</NavLink></li>
									<li><NavLink to="/blog">Blog</NavLink></li>
									<li><NavLink to="/contact-us">Contact Us</NavLink></li>
								</ul>
							</div>
						</div>
						
						<div className="col-sm-12 col-md-6 col-lg-2 col-xl-2">
						{/*<div className="menubox hire_menu">
								<div className="titlebox">
									<h4>Hire</h4>
								</div>
								
								<ul>
									<li><NavLink to="#">Offshore Marketing Team</NavLink></li>
									<li><NavLink to="#">Offshore Web Developers</NavLink></li>
								</ul>
						</div>*/}
							
							<div className="menubox services_menu">
								<div className="titlebox">
									<h4>Services</h4>
								</div>
								
								<ul>
									<li><NavLink to="/guest-posting-services">Guest Posting</NavLink></li>
									<li><NavLink to="/citations-services">Citations</NavLink></li>
									<li><NavLink to="/content-writing-services">Content Writing</NavLink></li>
								</ul>
							</div>
						</div>

						<div className="col-sm-12 col-md-6 col-lg-2 col-xl-2">
							<div className="menubox categories_menu">
								<div className="titlebox">
									<h4>Categories</h4>
								</div>
								<ul>
									<li><NavLink to="/category/technology">Technology</NavLink></li>
									<li><NavLink to="/category/saas">SaaS</NavLink></li>
									<li><NavLink to="/category/finance">Finance</NavLink></li>
									<li><NavLink to="/category/health">Health</NavLink></li>
									<li><NavLink to="/category/crypto">Crypto</NavLink></li>
									<li><NavLink to="/category/real-estate">Real Estate</NavLink></li>
									<li><NavLink to="/category/e-commerce">E-commerce</NavLink></li>
									<li><NavLink to="/category/digital-marketing">Digital Marketing</NavLink></li>
									<li><NavLink to="/category/business">Business</NavLink></li>
								</ul>
							</div>
						</div>
						
						<div className="col-sm-12 col-md-6 col-lg-3 col-xl-3">
							<div className="info_box">
								<div className="titlebox">
									<h4>Contact Details</h4>
								</div>
								
								<ul>
									<li>
										<div className="iconbox">
											<img src={`${homeUrl}/assets/img/mail_icon.png`} alt="Mail Icon" />
										</div>
										
										<div className="icontxt">
											<p><a href="mailto:hello@hypwave.com">hello@hypwave.com</a></p>
										</div>
									</li>
									<li>
										<div className="iconbox">
											<img src={`${homeUrl}/assets/img/telephone_icon.png`} alt="Telephone Icon" />
										</div>
										
										<div className="icontxt">
											<p><a href="tel:+919238777271">+91 92387 77271</a></p>
										</div>
									</li>
									<li>
										<div className="iconbox">
											<img src={`${homeUrl}/assets/img/location_icon.png`} alt="Location Icon" />
										</div>
										
										<div className="icontxt">
									  <p>
									    <a
									      href="https://maps.app.goo.gl/fB6biP56PQTAKv2F8"
									      target="_blank"
									      rel="noopener noreferrer"
									    >
									      Plot No. 55, 3rd Floor, Medanta Hospital Road, opposite Orange Lily Hotel, Vijay Nagar, Ratna Lok Colony, Indore, Madhya Pradesh 452010
									    </a>
									  </p>
									 </div>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
			
			<div className="copyright_mainsec">
				<div className="container">
					<div className="row">
						<div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<div className="copyright_txt">
								<p>Copyright © 2004 - 2026 Hypwave, All Rights Reserved. <NavLink to="/privacy-policy">Privacy Policy</NavLink></p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</footer>
		
		<WebsiteDevPopup homeUrl={homeUrl} />
		
		
	</div>
	</>
  );
}

export default App;
